import React from "react";
import "./modal.scss"; // Adjust the path as needed
import { Button, Modal, Tooltip } from "@forge/common";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../../common/store/combinedReducer";
import { hideModel } from "../../../store/model/model.action";

interface MyVerticallyCenteredModalProps {}

interface AppModal {
  open: boolean;
  options?: {
    fullScreen?: boolean;   
    childTemplate?: () => JSX.Element;}
  // add other properties if needed
}

function ModelPopup({}: MyVerticallyCenteredModalProps): JSX.Element {
    const dispatch = useDispatch();
  const { appModal } = useSelector((state: AppState) => state?.modalReducer) as { appModal: AppModal };

  return (
    <React.Fragment>
      {appModal?.open ? (
        <Modal
        className="model-Popup"
          onModalClose={() => dispatch(hideModel())}
        >
          {appModal?.options?.childTemplate ? appModal.options.childTemplate() : null}
        
        </Modal>
      ) : null}
    </React.Fragment>
  );
}

export default ModelPopup;
